// collectionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  loading: false,
  error: null,
};
const initialStateOnAir = {
  inArenaHorse: [],
  loading: false,
  error: null,
  viewHorseBox: false,
  inArenaHorseId: ''
};

const collectionSlice = createSlice({
  name: 'showTemporaryRanking',
  initialState,
  reducers: {
    fetchItemsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchItemsSuccess: (state, action) => {
      state.data = action.payload; // The real-time data array
      state.loading = false;
    },
    fetchItemsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearItems: (state) => { // Optional cleanup action
      state.data = [];
      state.error = null;
      state.loading = false;
    }
  },
});
const collectionSliceOnAir = createSlice({
  name: 'horseOnAir',
  initialState: initialStateOnAir,
  reducers: {
    fetchItemsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchItemsSuccess: (state, action) => {
      if (action.payload?.length > 0) {
        const payloadItem = action.payload[0];
        if (payloadItem?.Action == 5 ||  payloadItem?.Action == 3) {
          if (state.inArenaHorse.HorseId === payloadItem?.HorseId) {
            state.viewHorseBox = false;
            state.inArenaHorse = {};
          }
        }
        else if (payloadItem?.Action == 1) {
          state.viewHorseBox = true;
          state.inArenaHorse = payloadItem;
          state.inArenaHorseId = payloadItem?.HorseId;

        }
      } else {
        state.inArenaHorse = {};
      }
      state.loading = false;
    },
    fetchItemsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearItems: (state) => { // Optional cleanup action
      state.inArenaHorse = [];
      state.error = null;
      state.loading = false;
      state.viewHorseBox = false;
      state.inArenaHorseId = '';
    }
  },
});

export const { fetchItemsStart, fetchItemsSuccess, fetchItemsFailure, clearItems } = collectionSlice.actions;
export const { fetchItemsStart: fetchItemsStartOnAir, fetchItemsSuccess: fetchItemsSuccessOnAir, fetchItemsFailure: fetchItemsFailureOnAir, clearItems: clearItemsOnAir } = collectionSliceOnAir.actions;
export const ShowTemporaryRank = collectionSlice.reducer;
export const horseOnAir = collectionSliceOnAir.reducer;
